<div class="search-container">
    <div class="d-flex align-items-center mb-3" (click)="closeModal.emit()">
        <div class="arrowBack mr-2"></div>
        <p class="mb-0 text-size-2 color-omicron">Volver</p>
    </div>
    <app-general-search (searchEvent)="closeModal.emit()"></app-general-search>
</div>